import React, { useState } from "react";
import axios from "axios";
import HeadRegresar from "../../sharecomponents/HeadRegresar";
import { API_URL } from "../../../utils/Common";
import { ToastsContainer, ToastsStore, ToastsContainerPosition } from "react-toasts";
import BoxAlert from "../../sharecomponents/BoxAlert";

const initialFormData = Object.freeze({
   nombre_comun: "",
   nombre_cientifico: "",
   sexual: "",
   porcentaje: "0",
   densidad: "0",
   cavidad: "0",
   germinacion: "0",
   tallos: "0",
});

const initialVariedad = Object.freeze({
   nombre: "",
});

const NuevaFlor = (props) => {
   const [formData, updateFormData] = useState(initialFormData);

   const [variedades, setVariedades] = useState([]);
   const [variedad, setVariead] = useState(initialVariedad);

   const handleChange = (e) => {
      updateFormData({
         ...formData,
         // Trimming any whitespace
         [e.target.name]: e.target.value.trim(),
      });
   };

   const handleChangeVariedad = (e) => {
      setVariead({
         ...variedad,
         [e.target.name]: e.target.value,
      });
   };

   /**
    * OnSubmit envio de los datos
    */
   const onSubmit = async (e) => {
      e.preventDefault();
      console.log(formData);
      if (variedades.length > 0) {
         await axios
            .post(API_URL + "/flor/setFlor", { ...formData, variedades })
            .then((r) => {
               console.log(r.data);
               props.history.goBack();
            })
            .catch((err) => console.log(err));
      } else {
         ToastsStore.error("Ingrese de uno o mas variedades");
      }
   };

   const submitVariedad = (e) => {
      e.preventDefault();
      variedades.push(variedad);
      setVariedades([...variedades]);
      setVariead(initialVariedad);
   };

   const delVariedad = (v) => {
      let index = variedades.findIndex((i) => i.nombre === v.nombre);
      console.log(index);
      variedades.splice(index, 1);
      setVariedades([...variedades]);
   };

   return (
      <div className="w-full p-3">
         <div className="bg-white border rounded shadow">
            <div className="border-b rounded-t p-3 bg-orange-900">
               <HeadRegresar titulo="Alta de Nuevas Flores" history={props.history} />
            </div>
            <div className="p-5 rounded-b">
               <div className="w-full p-2 h-auto">
                  <h3 className="text-orange-900 font-bold">Datos Generales</h3>
                  <hr className="mb-5" />
                  <form className="w-full" onSubmit={onSubmit}>
                     <div className="flex flex-wrap -mx-3 mb-6">
                        {/* <div className="w-full md:w-1/6 px-3 mb-6 md:mb-0">
                           <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                              Código:
                           </label>
                           <input
                              className="text-sm appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                              name="codigo"
                              onChange={handleChange}
                              type="text"
                           />
                        </div>*/}
                        <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                           <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                              Nombre Común:
                           </label>
                           <input
                              className="text-sm appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                              name="nombre_comun"
                              value={formData.nombre_comun}
                              onChange={handleChange}
                              type="text"
                           />
                        </div>
                        <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                           <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                              Nombre Científico:
                           </label>
                           <input
                              className="text-sm appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                              name="nombre_cientifico"
                              type="text"
                              value={formData.nombre_cientifico}
                              onChange={handleChange}
                           />
                        </div>
                        {/*<div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                           <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                              Variedad:
                           </label>
                           <input
                              className="text-sm appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                              name="variedad"
                              onChange={handleChange}
                              type="text"
                           />
                         </div>*/}
                     </div>
                     <div className="flex flex-wrap -mx-3 mb-6">
                        {/*<div className="w-full md:w-1/4 px-3 mb-6 md:mb-0">
                           <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                              Color:
                           </label>
                           <div className="relative">
                              <select
                                 className="block text-sm appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                 name="color"
                                 id="color"
                                 onChange={handleChange}
                              >
                                 <option value="0">Ninguno</option> 
                                 {colores.map((c, i) => {
                                    return (
                                       <option key={c.id} value={c.id}>
                                          {c.color}
                                       </option>
                                    );
                                 })}
                              </select>
                              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                 <svg
                                    className="fill-current h-4 w-4"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20"
                                 >
                                    <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                                 </svg>
                              </div>
                           </div>
                        </div>*/}
                     </div>
                     <hr className="mb-5" />

                     <div className="flex flex-wrap -mx-3 mb-6">
                        <div className="w-full md:w-1/5 px-3 mb-6 md:mb-0">
                           <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                              Porcentaje Recuperación:
                           </label>
                           <input
                              className="text-sm text-right appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                              name="porcentaje"
                              step="any"
                              type="number"
                              value={formData.porcentaje}
                              onChange={handleChange}
                           />
                        </div>
                        <div className="w-full md:w-1/5 px-3 mb-6 md:mb-0">
                           <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                              Densidad:
                           </label>
                           <input
                              className="text-sm text-right appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                              name="densidad"
                              step="any"
                              type="number"
                              value={formData.densidad}
                              onChange={handleChange}
                           />
                        </div>
                        <div className="w-full md:w-1/5 px-3 mb-6 md:mb-0">
                           <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                              Cavidad:
                           </label>
                           <input
                              className="text-sm text-right appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                              name="cavidad"
                              step="any"
                              type="number"
                              value={formData.cavidad}
                              onChange={handleChange}
                           />
                        </div>
                        <div className="w-full md:w-1/5 px-3 mb-6 md:mb-0">
                           <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                              Germinación:
                           </label>
                           <input
                              className="text-sm text-right appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                              name="germinacion"
                              step="any"
                              type="number"
                              value={formData.germinacion}
                              onChange={handleChange}
                           />
                        </div>
                        <div className="w-full md:w-1/5 px-3 mb-6 md:mb-0">
                           <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                              Cantidad Tallos:
                           </label>
                           <input
                              className="text-sm text-right appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                              name="tallos"
                              step="any"
                              type="number"
                              value={formData.tallos}
                              onChange={handleChange}
                           />
                        </div>
                     </div>
                     <button
                        type="submit"
                        className="bg-orange-800 hover:bg-orange-700 text-white py-2 px-4 rounded shadow"
                     >
                        Guardar Flor
                     </button>
                  </form>
                  <h3 className="text-orange-900 font-bold mt-5">Ingreso de las Variedades</h3>
                  <hr className="mt-2" />
                  <div className="flex flex-wrap -mx-3 mb-6">
                     <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                        {/** Formulario ingreso del protocolo */}
                        <form className="mt-5" onSubmit={submitVariedad}>
                           <div className="text-sm flex flex-wrap -mx-3 mb-6">
                              <div className="w-1/2 px-3">
                                 <label className="block tracking-wide text-gray-700 font-bold mb-2">Variedad:</label>
                                 <input
                                    className="text-xs appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                    type="text"
                                    name="nombre"
                                    value={variedad.nombre}
                                    onChange={handleChangeVariedad}
                                 />
                              </div>
                              <div className="w-1/2 px-3 mt-8">
                                 <button
                                    className="text-sm bg-orange-700 hover:bg-orange-600 text-white py-2 px-4 rounded shadow focus:outline-none"
                                    type="submit"
                                 >
                                    Ingresar
                                 </button>
                              </div>
                           </div>
                        </form>
                        {/** ./formulario */}
                        <BoxAlert titulo="NOTA" mensaje="Es necesario ingresar variades para poder guardar la Flor" />
                     </div>
                     <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                        {/** tabla variedades */}
                        <table className="table-fixed mt-5">
                           <thead>
                              <tr className="border border-orange-800 text-white content-center bg-orange-800">
                                 <th></th>
                                 <th className="w-auto px-1 py-1">No</th>
                                 <th className="w-auto px-1 py-1">Nombre</th>
                              </tr>
                           </thead>
                           <tbody>
                              {variedades.length > 0 &&
                                 variedades.map((v, i) => {
                                    return (
                                       <tr key={i}>
                                          <td className="border px-4 py-2 m-0 w-5">
                                             <button
                                                className="px-1 py-1 focus:outline-none"
                                                onClick={() => delVariedad(v)}
                                             >
                                                <i className="far fa-trash-alt" />
                                             </button>
                                          </td>
                                          <td className="border px-4 py-2">{i + 1}</td>
                                          <td className="border px-4 py-2">{v.nombre}</td>
                                       </tr>
                                    );
                                 })}
                           </tbody>
                        </table>
                        {/** ./tabla variedades */}
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <ToastsContainer store={ToastsStore} position={ToastsContainerPosition.TOP_RIGHT} />
      </div>
   );
};

export default NuevaFlor;
